import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface PurchaseBundleState {
    showPurchaseBundlePopup: boolean;
    loadingPurchaseBundle: boolean;
}

const initialState = {
    showPurchaseBundlePopup: false,
    loadingPurchaseBundle: false,
};

export const purchaseBundleSlice = createSlice({
    name: "purchaseBundleState",
    initialState,
    reducers: {
        setPurchaseBundlePopupState: (
            state,
            data: PayloadAction<{ [key: string]: boolean }>,
        ) => {
            state.showPurchaseBundlePopup =
                data.payload.showPurchaseBundlePopup;
            state.loadingPurchaseBundle = data.payload.loadingPurchaseBundle;
            return state;
        },
        setShowPurchaseBundlePopup: (
            state,
            data: PayloadAction<{ [key: string]: boolean }>,
        ) => {
            state.showPurchaseBundlePopup =
                data.payload.showPurchaseBundlePopup;
            return state;
        },

        setLoadingPurchaseBundle: (
            state,
            data: PayloadAction<{ [key: string]: boolean }>,
        ) => {
            state.loadingPurchaseBundle = data.payload.loadingPurchaseBundle;
            return state;
        },
        resetPurchaseBundle: () => initialState,
    },
});

export const {
    setPurchaseBundlePopupState,
    setShowPurchaseBundlePopup,
    setLoadingPurchaseBundle,
    resetPurchaseBundle,
} = purchaseBundleSlice.actions;
